import { OnInit, Component, ViewChild, ElementRef, Output } from "@angular/core";
import { select } from "@angular-redux/store";
import { ToOperationalStatusType, TransportOrder } from "../../../pb-screen/models/transport-order/transport-order.interface";
import { Observable } from "rxjs";
import { OrderlineService } from "../../../shared/services/orderline.service";
import { PRE_PLANNED } from "../../../pb-screen/models/status-type.interface";
import { PlanningBlock } from "../../../pb-screen/models/planning-block/planning-block.interface";
import { ToScreenService } from "../../../pb-screen/services/to-screen.service";
import { OrderLine } from "../../../pb-screen/models/order-line/orderLine.interface";
import { ToActions } from "../../to.actions";
import { ToActionBarService } from "../../../pb-screen/services/to-action-bar.service";
import { PbActions } from "../../../pb-screen/pb.actions";
import { PbScreenService } from "../../../pb-screen/services/pb-screen.service";
import { SharedActions } from "../../../shared/shared.actions";
import { PlanningConflict } from "../../../pb-screen/models/planning-conflict.interface";
import { SharedService } from "../../../shared/services/shared.service"
import * as moment from 'moment';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogService } from '../../../shared/components/confirm-dialog/confirm-dialog.service';
import { PrintlistComponent } from '../../modals/print-list-modal/print-list-modal.component';
import { SimpleModalService } from 'ngx-simple-modal';
import { ToPlanningModalComponent } from '../../modals/planning-modal/to-planning-modal.component';
import { PbDetailsComponent } from '../../../pb-screen/containers/display/pb-details/pb-details.component';
import { PlanningBoardActions } from '../../../planningBoard/planningBoard.action';
import { MapService } from "../../../shared/services/map.service";
import { take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { UserFeedbackService } from "../../../services/user-feedback.service";
import { error } from 'console';
import { ApplicationUser } from "../../../pb-screen/models/application.user.interface";
import { OrderLineActionsEnum } from "../../../shared/models/orderline.interface";
import { EventEmitter } from "@angular/core";
import {
  ConfirmationModalComponent,
  ConfirmationModalResult
} from "../../../shared/containers/confirmation-modal/confirmation-modal.component";
import { DevLoggerService } from "../../../shared/services/dev-logger.service";


@Component({
  moduleId: module.id,
  selector: "to-action-bar",
  templateUrl: "./to-action-bar.component.html"
})

export class ToActionBarComponent implements OnInit {
  @ViewChild("modal", { read: ElementRef }) public modal: ElementRef;
  @Output() public closeModalRequestEvent: EventEmitter<any> = new EventEmitter();
  @select("selectedTransportOrders") public selectedTransportOrders$: Observable<TransportOrder[]>;
  @select("selectedOrderlines") public selectedOrderlines$: Observable<OrderLine[]>;
  @select("selectedPlanningBlocks") public selectedPlanningBlocks$: Observable<PlanningBlock[]>;
  @select("orderLines") public orderLines$: Observable<OrderLine[]>;
  @select("loading") public loading$: Observable<boolean>;
  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
  @select('cancelPbBtnState') public cancelPbBtnState$: Observable<boolean>;
  @select('sendPbBtnState') public sendPbBtnState$: Observable<boolean>;
  @select('unplanPbBtnState') public unplanPbBtnState$: Observable<boolean>;
  @select('pbDetailsFromTo') public pbDetailsFromTo$: Observable<boolean>;
  @select("toPlanBtnState") public toPlanBtnState$: Observable<boolean>;
  @select('orderlinesForTO') public orderlinesForTO$: Observable<TransportOrder>;

  public selectedTransportOrder: TransportOrder;
  public planningBlocksForTo: PlanningBlock[] = [];
  public selectedOrderlines: OrderLine[] = [];
  public selectedPlanningBlocks: PlanningBlock[] = [];
  public resetButtonHovered: boolean = false;
  public toPlanBtnState: boolean = false;
  notificationButton: boolean = false;
  cancelPbBtnState: boolean = false;
  sendPbBtnState: boolean = false;
  unplanPbBtnState: boolean = false;
  private unplanToBtnState: boolean = false;
  private unplanState: boolean = false;
  tooltip: string = "Unplan TO";
  readyToUnplan: boolean = false;
  sendBtnState: boolean = false;
  pbDetailsFromTo: boolean = false;
  public orderLines: OrderLine[] = [];
  public displayConflicts: boolean = false;
  public ConflictsList: PlanningConflict[];
  private LastCallBack: Function;
  private orderlineModalState: boolean = false;
  public sendToState: boolean = false;
  public loadingSpinner: boolean = false;
  private user : ApplicationUser ;
  public assignCapacityState: boolean = false;

  constructor(private readonly orderlineService: OrderlineService,
    private readonly pbScreenService: PbScreenService,
    private readonly toService: ToScreenService,
    private readonly toActions: ToActions,
    private readonly sharedActions: SharedActions,
    private readonly toActionBarService: ToActionBarService,
    private readonly sharedService: SharedService,
    private readonly pbActions: PbActions,
    private readonly simpleModalService: SimpleModalService,
    private readonly confirmDialogService: ConfirmDialogService,
    private readonly planningBoardActions: PlanningBoardActions,
    private mapService: MapService,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly trasnlateService: TranslateService,
    private readonly devLogger: DevLoggerService) { }

  ngOnInit(): void {

    this.loading$.subscribe((data) => {
      if (!data) {
        this.loadingSpinner = data;
      }
    });



    this.toPlanBtnState$.subscribe((toPlanBtnState: boolean) => {
      this.toPlanBtnState = toPlanBtnState;
    });

    this.selectedPlanningBlocks$.subscribe((planningBlocks: PlanningBlock[]) => {
      this.selectedPlanningBlocks = planningBlocks;
    });

    this.cancelPbBtnState$.subscribe((res) => {
      this.cancelPbBtnState = res;
    });

    this.sendPbBtnState$.subscribe((res) => {
      this.sendPbBtnState = res;
    });

    this.pbDetailsFromTo$.subscribe((res) => {
      this.pbDetailsFromTo = res;
    });

    this.unplanPbBtnState$.subscribe((res) => {
      this.unplanPbBtnState = res;
    });


    this.selectedOrderlines$.subscribe((orderlines: OrderLine[]) => {
      if (orderlines) {
        this.selectedOrderlines = orderlines;
        this.setBtnStates();
        this.tooltip = "Unplan Selected Planning Blocks";

        this.setOrderlineSelectionButtonStates();
      }
    });

    this.applicationUser$.subscribe((applicationUser) => {
      if (applicationUser) {
        this.user = applicationUser;
      }
    });
  }

  public setSelectedTransportOrder(transportOrder: TransportOrder) {
    if (transportOrder) {
      this.selectedTransportOrder = transportOrder;
      this.sendToState = false;

      this.planningBlocksForTo = transportOrder.planningBlocks;
      if (this.selectedTransportOrder && this.planningBlocksForTo) {
        this.readyToUnplan = this.planningBlocksForTo.every((element, index, array) => {
          return element.status.statusType === PRE_PLANNED;
        });
      }

      if (this.selectedTransportOrder.haulierName !== "") {
        this.sendToState = true;
      }

      if (this.selectedTransportOrder.toOperationalStatusType !== ToOperationalStatusType.InProgress && this.selectedTransportOrder.toOperationalStatusType !== ToOperationalStatusType.Closed) {
        this.assignCapacityState = true;
      } else {
        this.assignCapacityState = false;
      }
      if (this.selectedTransportOrder.orderlines) {
        this.sendBtnState = this.selectedTransportOrder.orderlines.every((element, index, array) => {
          return element.sentToHaulier === 1;
        });
      }

    } else {
      this.assignCapacityState = false;
    }
  }


  private setOrderlineSelectionButtonStates() {
    this.unplanState = this.selectedOrderlines.length > 0 ? true : false;
    this.notificationButton = this.selectedOrderlines.length === 1 ? true : false;
    this.orderlineModalState = this.selectedOrderlines.length === 1 ? true : false;
  }

  IsNoPlanningRequiredEnabled() {
    if (this.selectedOrderlines.length > 0) {
      for (var i in this.selectedOrderlines) {
        let orderLine = this.selectedOrderlines[i];
        if (!(orderLine.actionType == OrderLineActionsEnum.Drop_at || orderLine.actionType == OrderLineActionsEnum.Pickup || OrderLineActionsEnum.DOut == orderLine.actionType ||
          OrderLineActionsEnum.DIn == orderLine.actionType ||
          OrderLineActionsEnum.Uncouple == orderLine.actionType || OrderLineActionsEnum.Couple == orderLine.actionType)) {
          return false;
        }
        if (orderLine.orderNumber.toString() == "") {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  CancelOperation() {
    this.displayConflicts = false;
    this.ConflictsList = [];
  }

  ConfirmOperation() {
    this.displayConflicts = false;
    this.ConflictsList = [];
    this.LastCallBack.call(null);


  }

  NoPlanningRequired() {
    if (!this.selectedTransportOrder && !this.selectedTransportOrder.id) {
      this.userFeedbackService.showErrorMessage("SHARED.ERROR_NO_TRANSPORT_ORDER_SELECTED");
      return;
    }

    this.loadingSpinner = true;
    this.toService.NoPlanningRequired(this.selectedTransportOrder, this.selectedOrderlines).subscribe((data) => {
      if (data == "") {
        this.userFeedbackService.showSuccessMessage("SHARED.OPERATION_SUCCESS");
      } else {
        this.userFeedbackService.showErrorMessage("SHARED.ERROR_REMOVE_LINES", { error: data });
      }

      if (this.selectedTransportOrder) {
        this.toService.getTransportOrderById(this.selectedTransportOrder.id, true).subscribe((transportOrders: TransportOrder) => {
          if (transportOrders) {
            this.sharedActions.getOrderlines(transportOrders.orderlines);
            this.planningBlocksForTo = transportOrders.planningBlocks;
            this.toActions.updateTransportOrdersDisplay([transportOrders]);
            this.loadingSpinner = false;
          }
        });
        this.loadingSpinner = false;
        this.resetSelection();
      }
    });
  }
  sendNextPb() {
    let planningBlockIds = [];
    this.sharedActions.setLoading(true);
    this.toService.getTransportOrderDetails(this.selectedTransportOrder.id).subscribe((orderlines) => {
      this.sharedActions.getOrderlines(orderlines);
      orderlines.forEach((value, index) => {
        if (!value.sentToHaulier) {
          if (planningBlockIds.indexOf(value.planningBlockId) === -1)
            planningBlockIds.push({ id: value.planningBlockId });
        }

      });
      this.CheckConflicts(() => {
        this.orderlineService.sendNextPb(this.selectedTransportOrder).subscribe((data) => {
          this.sharedActions.setLoading(false);
        },
          error => {
            this.sharedActions.setLoading(false);
          });
      }, planningBlockIds);
    });

  }

  sendTo() {
    if (this.selectedTransportOrder.sentToBc === 1) {
      let date = new Date(this.selectedTransportOrder.toSentDateTime);

      this.trasnlateService.get(
        "SHARED.SELECTED_TRANSPORT_ORDER_ALREADY_SENT_TO_BC",
        { date: moment(date).format("L LT") }
      ).subscribe(res => {
        this.confirmDialogService.confirmThis(res, () => {
          this.CheckConflicts(() => {
            this.sendToHaulier([this.selectedTransportOrder.id]);
          }, null);
        }, () => {
        });
      });
    } else {
      this.CheckConflicts(() => {
        this.sendToHaulier([this.selectedTransportOrder.id]);
      }, null);
    }
  }

  sendToHaulier(toNumbers: string[]) {
    this.sharedActions.setLoading(true);

    this.toService.sendToToHaulier(toNumbers).subscribe((res: TransportOrder[]) => {
      this.sharedActions.setLoading(false);

      this.toActions.updateTransportOrdersDisplay(res);
      this.userFeedbackService.showSuccessMessage("SHARED.TRANSPORT_ORDER_SENT_SUCCESSFULLY");
    }, error => {
      this.sharedActions.setLoading(false);
    });
  }


  CheckConflicts(callback, pbArray: any) {
    this.devLogger.conflict(`CheckConflicts called for TO: ${this.selectedTransportOrder?.id}`, { pbArrayLength: pbArray?.length || 'null' });
    this.sharedService.calculatePlanningBlockConflicts(this.selectedTransportOrder.id).subscribe((conflictData) => {
      this.devLogger.conflict(`CheckConflicts response: ${conflictData.length} conflicts found`, conflictData);
      if (pbArray == null && conflictData.length > 0) {
        this.devLogger.conflict('Displaying conflicts modal');
        this.displayConflicts = true;
        this.ConflictsList = conflictData;
        this.LastCallBack = callback;
      } else if (conflictData.length == 0) {
        this.devLogger.conflict('No conflicts, proceeding with callback');
        this.displayConflicts = false;
        this.ConflictsList = null;
        this.LastCallBack = null;
        callback.call(null);
      } else if (pbArray != null) {
        let pbConficts = [];

        for (const pbIndex in pbArray) {
          for (const conflictIndex in conflictData) {
            if (conflictData[conflictIndex].pbId == pbArray[pbIndex].id.toString()) {
              pbConficts.push(conflictData[conflictIndex]);
            }
          }
        }

        if (pbConficts.length > 0) {
          this.devLogger.conflict(`PB-specific conflicts found: ${pbConficts.length}`);
          this.displayConflicts = true;
          this.ConflictsList = conflictData;
          this.LastCallBack = callback;
        } else {
          this.devLogger.conflict('No PB-specific conflicts, proceeding');
          this.displayConflicts = false;
          this.ConflictsList = null;
          this.LastCallBack = null;
          callback.call(null);
        }
      }
    });
  }

  cancelTo() {
    this.sharedActions.setLoading(true);

    this.orderlineService.cancelTo(this.selectedTransportOrder).subscribe((res) => {
      this.pbActions.updatePlanningBlocksDisplay(res.planningBlocks, true);
      this.readyToUnplan = true;
      this.sharedActions.setLoading(false);

    }, error => {
      this.sharedActions.setLoading(false);

    });
  }

  unplanForSelectedOrderlines() {

    let planningBlockIds = this.selectedOrderlines.map(ol => ol.planningBlockId);
    let selectedPlanningBlocks = this.planningBlocksForTo.filter((pb) => planningBlockIds.includes(pb.id) && pb.status.statusType === PRE_PLANNED);
    this.sharedActions.setLoading(true);
    this.pbScreenService.unplanPlanningBlocks(selectedPlanningBlocks, false).subscribe((planningBlocks: PlanningBlock[]) => {
      this.pbActions.updatePlanningBlocksDisplay(planningBlocks, true);
      this.toActions.setSelectedTransportOrders([]);
      this.userFeedbackService.showSuccessMessage("SHARED.PLANNING_BLOCK_SUCCESSFULLY_UNPLANNED");
      this.sharedActions.setLoading(false);
      this.resetSelection();
      this.closeModal();
    }, error => {
      this.sharedActions.setLoading(false);

    });
  }

  cancelPbs() {
    if (this.planningBlocksForTo && this.selectedOrderlines) {
      this.sharedActions.setLoading(true);
      this.orderlineService.cancelPb(this.selectedPlanningBlocks).subscribe((data) => {
        this.sharedActions.setLoading(false);
      },
        error => {
          this.sharedActions.setLoading(false);

        });
    }
  }

  unplanPbs() {
    if (this.planningBlocksForTo && this.selectedOrderlines) {
      this.sharedActions.setLoading(true);
      this.pbScreenService.unplanPlanningBlocks(this.selectedPlanningBlocks, false).subscribe((planningBlocks: PlanningBlock[]) => {
        if (this.planningBlocksForTo.length === planningBlocks.length) {
          this.orderlineService.deleteTo(this.selectedTransportOrder, "");
          this.closeModal();
        }

        this.sharedActions.setLoading(false);

      }, error => {
        this.sharedActions.setLoading(false);
      });
      this.closeModal();
    }

  }

  sendPbs() {
    if (this.planningBlocksForTo && this.selectedOrderlines) {

      this.CheckConflicts(() => {
        this.sharedActions.setLoading(true);
        this.orderlineService.sendPb(this.selectedPlanningBlocks).subscribe((data) => {
          this.toService.getTransportOrderDetails(this.selectedTransportOrder.id).subscribe((orderlines) => {
            this.sharedActions.setLoading(false);
            this.sharedActions.getOrderlines(orderlines);
          }, error => {
            this.sharedActions.setLoading(false);
          });
        });
      }, this.selectedPlanningBlocks);
    }
  }

  setBtnStates() {
    if (this.planningBlocksForTo && this.selectedOrderlines) {
      let planningBlockIds = this.selectedOrderlines.map(ol => ol.planningBlockId);
      let selectedPlanningBlocks = this.planningBlocksForTo.filter((pb) => planningBlockIds.includes(pb.id));
      this.unplanToBtnState = selectedPlanningBlocks.every((element, index, array) => {
        return element.status.statusType === PRE_PLANNED;
      });
    }
  }

  setPbBtnStatus() {
    this.planningBlocksForTo.forEach((element) => {
      this.selectedOrderlines.forEach((orderline) => {
        if (element.id === orderline.planningBlockId && !this.selectedPlanningBlocks.includes(element)) {

          this.selectedPlanningBlocks.push(element);
        }
      });
    });
  }

  public unplanTO() {
    this.loadingSpinner = true;
    this.sharedActions.setLoading(true);
    this.orderlineService.unplanTo(this.planningBlocksForTo, this.selectedTransportOrder).subscribe((res) => {
      this.toActions.removeTransportOrdersFromStore([this.selectedTransportOrder]);
      this.loadingSpinner = false;
      this.sharedActions.setLoading(false);
      this.resetSelection();
      this.toActions.setSelectedTransportOrders([]);
      this.closeModal();

    }, error => {
      this.loadingSpinner = false;
      this.sharedActions.setLoading(false)
    });
  }

  resetSelection() {
    this.toActions.setSelectedOrderlines([]);
    this.unplanToBtnState = false;
    this.toActionBarService.resetActionBar();
  }

  private closeModal(): void {
    if (this.closeModalRequestEvent) {
      this.closeModalRequestEvent.emit();
    }
    this.resetSelection();
  }

  public ScreenName() {
    this.sharedService.ScreenName = "TO-Screen-Details";
  }

  public openPrintModal() {
    this.ScreenName();
    this.simpleModalService.addModal(PrintlistComponent)
      .subscribe(() => {
      });
  }

  public setSelectedPb() {
    let pbId = [this.selectedOrderlines[0].planningBlockId];
    this.pbScreenService.getPlanningBlocksByIds(pbId).subscribe((data: PlanningBlock[]) => {
      this.pbActions.setSelectedPlanningBlocks([...data]);
    });
    this.simpleModalService.addModal(PbDetailsComponent, { source: "to-screen" })
      .subscribe(() => {
      });
  }


  public groupSelectedLines() {
    this.loadingSpinner = true;
    var lineOrderIds = this.selectedOrderlines.map(x => x.orderLineId).join("%7C");

    if (this.selectedOrderlines.length > 1) {
      this.orderlineService.groupSelectedLines(this.selectedTransportOrder, this.selectedTransportOrder.id, lineOrderIds).subscribe((data) => {
        this.toService.getTransportOrderDetails(this.selectedTransportOrder.id).subscribe((orderlines: any[]) => {
          this.sharedActions.getOrderlines(orderlines);
        });
        this.toActions.setSelectedOrderlines([]);
        this.userFeedbackService.showSuccessMessage("SHARED.GROUPED_LINES_SUCCESSFULLY", undefined, "SHARED.GROUP_LINES");

        this.loadingSpinner = false;
      }, (err) => {
        this.loadingSpinner = false;
      });
    } else {
      this.userFeedbackService.showWarningMessage("SHARED.PLEASE_SELECT_MINIMUM_LINES_TO_GROUP", undefined, "SHARED.GROUP_LINES");
      this.loadingSpinner = false;
    }
  }


  public ungroupSelectedLines() {
    this.loadingSpinner = true;
    var lineOrderIds = this.selectedOrderlines.map(x => x.orderLineId).join("%7C");

    if (this.selectedOrderlines.length > 1) {
      this.orderlineService.unGroupSelectedLines(this.selectedTransportOrder, this.selectedTransportOrder.id, lineOrderIds).subscribe((data) => {
        this.toService.getTransportOrderDetails(this.selectedTransportOrder.id).subscribe((orderlines: any[]) => {
          this.sharedActions.getOrderlines(orderlines);

        });

        this.toActions.setSelectedOrderlines([]);
        this.selectedPlanningBlocks = [];
        this.resetSelection();
        this.userFeedbackService.showSuccessMessage("SHARED.UNGROUPED_LINES_SUCCESSFULLY", undefined, "SHARED.UNGROUP_LINES");
        this.loadingSpinner = false;

      }, (err) => {
        this.loadingSpinner = false;
      });
    } else {
      this.userFeedbackService.showWarningMessage("SHARED.PLEASE_SELECT_MINIMUM_LINES_TO_UNGROUP", undefined, "SHARED.UNGROUP_LINES");
      this.loadingSpinner = false;
    }
  }


  public setSelectedTOForCapacityModal() {
    this.toActions.setSelectedTransportOrders([this.selectedTransportOrder]);

    this.simpleModalService.addModal(ToPlanningModalComponent, {})
      .subscribe(() => {
      });
  }

  public recalculateTo() {
    this.loadingSpinner = true;
    this.toService.recalculateTO(this.selectedTransportOrder.id).subscribe((result) => {
      this.loadingSpinner = false;
      this.planningBoardActions.UpdatePlanningDisplay([result]);
      this.userFeedbackService.showSuccessMessage("SHARED.TRANSPORT_ORDER_RECALCULATED_SUCCESSFULLY");

    });
  }


  handleShowMap() {
    if (!this.selectedTransportOrder?.id) {
      this.orderlinesForTO$
        .pipe(take(1))
        .subscribe((orderlines: any) => {
          this.mapService.openMapForTO(orderlines[0].transportOrderId);
        });
    } else {
      this.mapService.openMapForTO(this.selectedTransportOrder.id);
    }
  }

  shouldShowCloseToModal(){
    return this.user.generalSetting.closeTransportOrderOnOrderlinesDock ?? false;
  }

  showCloseToModal() {
    const storageKey = `skipConfirm:closeTo`;
    const skip = localStorage.getItem(storageKey) === "true";

    if (skip) {
      this.closeTo();
      return;
    }

    this.simpleModalService
      .addModal(ConfirmationModalComponent, {
        title: "SHARED.CLOSE_TRANSPORT_ORDER",
        messageTranslationKey: "SHARED.CLOSE_TRANSPORT_ORDER_CONFIRMATIONMESSAGE",
        showDontAskAgain: true,
        executeIconClass: "fa-check",
        isActionDanger: false
      })
      .subscribe((result: ConfirmationModalResult) => {
        if (result && result.confirmed) {
          if (result.dontAskAgain) {
            localStorage.setItem(storageKey, "true");
          }
          this.closeTo();
        }
      });
  }

  closeTo() {
    this.planningBoardActions.setLoading(true);
    this.toService.closeTo(this.selectedTransportOrder).subscribe((data) => {
      this.planningBoardActions.setLoading(false);
    });
  }
}
